import { render, staticRenderFns } from "./view-all-loads.component.vue?vue&type=template&id=5fe5ab0f&scoped=true"
import script from "./view-all-loads.component.vue?vue&type=script&lang=js"
export * from "./view-all-loads.component.vue?vue&type=script&lang=js"
import style0 from "./view-all-loads.component.vue?vue&type=style&index=0&id=5fe5ab0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5ab0f",
  null
  
)

export default component.exports